import { kr, PRICES } from '../app/v2/prices';
export const SeoUtils = {
  notfound: {
    title: 'Moderna Media - Siden finnes ikke',
    description:
      'Denne siden finnes ikke lengre - Moderna Media Digitalbyrå - Invester i vekst',
    robots: 'noindex, follow',
  },
  home: {
    title: 'Digitalbyrå i Oslo | Nettside, Design & SEO | Moderna Media',
    description:
      `Digitalbyrå i Oslo som lager nettsider, design og SEO for bedrifter. Nettsider fra ${kr(PRICES.nettside)} eks. mva. Få et uforpliktende tilbud – svar innen 2 timer.`,
    keywords:
      'digitalbyrå, nettside bedrift, webdesign oslo, SEO byrå, logo design, webutvikling',
  },
  TjenesterUtvikling: {
    title: 'Nettside for bedrift & webutvikling i Oslo | Moderna Media',
    description:
      `Vi lager raske, skreddersydde nettsider og programvare for bedrifter i Oslo og hele Norge. Nettsider fra ${kr(PRICES.nettside)} eks. mva – få et uforpliktende tilbud.`,
    keywords:
      'nettside bedrift, webutvikling, React, Angular, Next.js, webapplikasjon',
  },
  TjenesterSeo: {
    title: 'SEO-byrå i Oslo | Søkemotoroptimalisering | Moderna Media',
    description:
      `Bli synlig på Google med SEO fra ${kr(PRICES.seo)}/mnd eks. mva. Teknisk SEO, innholdsproduksjon og off-page SEO med målbare resultater. Bestill gratis SEO-analyse.`,
    keywords:
      'SEO, søkemotoroptimalisering, Google rangering, teknisk SEO, lokal SEO',
  },
  TjenesterDesign: {
    title: 'Logo design, webdesign & grafisk design i Oslo | Moderna Media',
    description:
      `Profesjonell logo design, webdesign og grafisk design for bedrifter. Design fra ${kr(PRICES.design)} eks. mva. Book et uforpliktende møte med Moderna Media i Oslo.`,
    keywords:
      'logo design, webdesign, grafisk design, merkevarebygging, visuell identitet',
  },
  FormsKontakt: {
    title: 'Kontakt Oss | Moderna Media Digitalbyrå',
    description:
      'Ta kontakt med Moderna Media for en uforpliktende samtale om din bedrifts digitale behov. Vi svarer raskt og hjelper deg gjerne.',
    keywords: 'kontakt digitalbyrå, gratis konsultasjon, nettside tilbud',
  },
  FormsSeoAudit: {
    title: 'Gratis SEO-analyse | Moderna Media',
    description:
      'Få en gratis SEO-analyse av nettsiden din. Vi identifiserer forbedringspotensialet og gir deg konkrete tips for bedre synlighet på Google.',
    keywords:
      'gratis SEO analyse, SEO sjekk, nettside analyse, Google rangering',
  },
  FormsWebsiteAudit: {
    title: 'Gratis Nettside-analyse | Moderna Media',
    description:
      'Bestill en gratis analyse av nettsiden din. Vi vurderer design, hastighet, brukervennlighet og SEO - og gir deg en rapport med forbedringer.',
    keywords:
      'nettside analyse, gratis hjemmeside sjekk, UX analyse, nettside vurdering',
  },
  FromsPrice: {
    title: 'Få Pristilbud på Nettside, Design eller SEO | Moderna Media',
    description:
      'Be om et uforpliktende pristilbud på nettside, webdesign, logo eller SEO. Konkurransedyktige priser og høy kvalitet for norske bedrifter.',
    keywords: 'nettside pris, webdesign kostnad, SEO pris, logo pris',
  },
  BloggRestaurantHjemmeside: {
    title: 'Hvorfor Trenger en Restaurant en Nettside? | Moderna Media Blogg',
    description:
      '82% av kunder er mer tilbøyelige til å besøke en restaurant etter å ha sett nettsiden. Les hvorfor din restaurant trenger en profesjonell nettside.',
    keywords:
      'restaurant nettside, restaurant markedsføring, digital tilstedeværelse restaurant',
  },
  Blogg: {
    title: 'Blogg | Digital Markedsføring & Webutvikling | Moderna Media',
    description:
      'Les våre artikler om digital markedsføring, SEO, webutvikling og design. Tips og innsikt for bedrifter som vil vokse digitalt.',
    keywords: 'digital markedsføring blogg, SEO tips, webutvikling artikler',
  },
  CaseStudies: {
    title: 'Kundehistorier & Case Studies | Moderna Media',
    description:
      'Se hvordan vi har hjulpet norske bedrifter med nettsider, SEO og design. Les våre case studies og se resultatene.',
    keywords:
      'case studies, kundehistorier, nettside prosjekter, SEO resultater',
  },
  // Sub-service pages
  UtviklingHjemmeside: {
    title: 'Hjemmeside for Bedrift | Profesjonell Nettside | Moderna Media',
    description:
      'Få en profesjonell hjemmeside som konverterer besøkende til kunder. Responsivt design, rask lasting og SEO-optimalisert fra dag én.',
    keywords: 'hjemmeside bedrift, profesjonell nettside, responsiv webdesign',
  },
  UtviklingProgramvare: {
    title: 'Programvareutvikling & Webapplikasjoner | Moderna Media',
    description:
      'Skreddersydd programvare og webapplikasjoner for din bedrift. Vi bygger løsninger som effektiviserer arbeidsflyten din.',
    keywords:
      'programvareutvikling, webapplikasjon, custom software, bedriftsløsninger',
  },
  SeoTeknisk: {
    title: 'Teknisk SEO | Optimaliser Nettsiden Din | Moderna Media',
    description:
      'Forbedre nettsidens tekniske ytelse for bedre Google-rangering. Core Web Vitals, hastighet, struktur og crawlability.',
    keywords: 'teknisk SEO, Core Web Vitals, nettside hastighet, crawlability',
  },
  SeoInnhold: {
    title: 'SEO Innholdsproduksjon | Innholdsmarkedsføring | Moderna Media',
    description:
      'Profesjonell innholdsproduksjon som rangerer på Google. Vi skriver SEO-optimaliserte artikler og nettsider som tiltrekker kunder.',
    keywords:
      'SEO innhold, innholdsmarkedsføring, artikkelskriving, content marketing',
  },
  SeoOffPage: {
    title: 'Off-Page SEO & Linkbygging | Moderna Media',
    description:
      'Styrk nettsidens autoritet med profesjonell off-page SEO og kvalitetslenker. Øk synligheten og rangeringen på Google.',
    keywords: 'off-page SEO, linkbygging, backlinks, domeneautoritet',
  },
  DesignLogo: {
    title: 'Logo Design | Unik Logo for Din Bedrift | Moderna Media',
    description:
      'Få en profesjonell og unik logo som representerer bedriften din. Vi designer logoer som skiller seg ut og bygger merkevaren.',
    keywords: 'logo design, bedriftslogo, merkevareidentitet, visuell profil',
  },
  DesignWeb: {
    title: 'Webdesign | Moderne UI/UX Design | Moderna Media',
    description:
      'Profesjonelt webdesign som kombinerer estetikk og brukervennlighet. Vi designer nettsider som engasjerer og konverterer.',
    keywords: 'webdesign, UI design, UX design, moderne nettside design',
  },
  DesignGrafisk: {
    title: 'Grafisk Design | Visuelt Materiell for Bedrifter | Moderna Media',
    description:
      'Profesjonell grafisk design for trykk og digital bruk. Brosjyrer, visittkort, sosiale medier-grafikk og mer.',
    keywords: 'grafisk design, brosjyrer, visittkort, markedsføringsmateriell',
  },
};
